import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$: Observable<boolean> = this.loadingSubject.asObservable();

    constructor() {}

    /**
     * Turns on the loading overlay
     */
    loadingOn(): void {
        this.loadingSubject.next(true);
    }

    /**
     * Turns off the loading overlay
     */
    loadingOff(): void {
        this.loadingSubject.next(false);
    }
}
